﻿import api from '@core/services/api/_api';
import ENUMS from '@core/classes/Enums';

import util from '@core/services/util';
import MapsService from '@core/services/maps';
import DropdownHelper from '@core/helpers/dropdown-helper';
import settings from 'settings';

export function prefixList(keys, language, application, toggleLoadingQuestion) {
	const prefixList = [
		{ value: 'Dr.', English: 'Dr.', Spanish: 'Dr(a).' },
		{ value: 'Mr.', English: 'Mr.', Spanish: 'Sr.' },
		{ value: 'Mrs.', English: 'Mrs.', Spanish: 'Sra.' },
		{ value: 'Ms.', English: 'Ms.', Spanish: 'Srta.' },
		{ value: 'Mx.', English: 'Mx.', Spanish: 'Sx.' },
	];

	let dropdownDataList = [];

	prefixList.forEach(d => {
		dropdownDataList.push({ [keys.text]: d[language], [keys.value]: d.value });
	});

	return dropdownDataList;
}

export function suffixList(keys, language, application, toggleLoadingQuestion) {
	const suffixList = [
		{ value: 'Jr.', English: 'Jr.', Spanish: 'Jr.' },
		{ value: 'Sr.', English: 'Sr.', Spanish: 'Sr.' },
		{ value: 'II', English: 'II', Spanish: 'II' },
		{ value: 'III', English: 'III', Spanish: 'III' },
		{ value: 'IV', English: 'IV', Spanish: 'IV' },
		{ value: 'other', English: 'Other', Spanish: 'Otro' },
	];

	let dropdownDataList = [];

	suffixList.forEach(d => {
		dropdownDataList.push({ [keys.text]: d[language], [keys.value]: d.value });
	});

	return dropdownDataList;
}

export function immigrationStatusList(keys, language, application, toggleLoadingQuestion) {
	let dropdownDataList = [];

	ENUMS.IMMIGRATION_STATUS_TITLE.forEach(d => {
		dropdownDataList.push({
			[keys.text]: d[language],
			[keys.value]: d.value,
		});
	});

	return dropdownDataList;
}

export function usStatesList(keys, language, application, toggleLoadingQuestion) {
	let dropdownDataList = [];

	ENUMS.states.forEach(s => {
		if (!s.isUSTerritory) {
			dropdownDataList.push({
				[keys.text]: s.description,
				[keys.value]: s.code,
			});
		}
	});

	return dropdownDataList;
}

export function usTerritories(keys, language, application, toggleLoadingQuestion) {
	const usTerritories = [
		{
			value: 'US',
			English: 'United States',
			Spanish: 'Estados Unidos de América',
		},
		{ value: 'PR', English: 'Puerto Rico', Spanish: 'Puerto Rico' },
		{ value: 'GU', English: 'Guam', Spanish: 'Guam' },
		{
			value: 'VI',
			English: 'U.S. Virgin Islands',
			Spanish: 'Islas Vírgenes de los Estados Unidos',
		},
		{ value: 'AS', English: 'American Samoa', Spanish: 'Samoa Americana' },
		{
			value: 'MP',
			English: 'Northern Mariana Islands',
			Spanish: 'Islas Marianas del Norte',
		},
	];

	let dropdownDataList = [];

	usTerritories.forEach(d => {
		dropdownDataList.push({ [keys.text]: d[language], [keys.value]: d.value });
	});

	return dropdownDataList;
}

export function countries(keys, language, application, toggleLoadingQuestion) {
	let languageCode = 'en';
	if (language == 'Spanish') {
		languageCode = 'es';
	}

	let usAndUSTerritories = ENUMS.states
		.filter(s => s.isUSTerritory)
		.map(s => s.code)
		.concat('US');
	let countries = settings.countries.filter(c => !usAndUSTerritories.includes(c.countryCode));

	let dropdownDataList = [];

	countries?.forEach(c => {
		let text = c.nameTranslations.find(n => n.languageCode == languageCode).value;
		let value = c.countryCode;
		dropdownDataList.push({ [keys.text]: text, [keys.value]: value });
	});

	return dropdownDataList;
}

export function howManyVehicles(keys, language, application, toggleLoadingQuestion) {
	const vehicleOwnershipType = [
		{ value: 0, English: '0', Spanish: '0' },
		{ value: 1, English: '1', Spanish: '1' },
		{ value: 2, English: '2', Spanish: '2' },
		{ value: 3, English: '3+', Spanish: '3+' },
	];

	let dropdownDataList = [];

	vehicleOwnershipType.forEach(v => {
		dropdownDataList.push({ [keys.text]: v[language], [keys.value]: v.value });
	});

	return dropdownDataList;
}

export function vehicleOwnershipType(keys, language, application, toggleLoadingQuestion) {
	const vehicleOwnershipType = [
		{ value: 'own', English: 'Own', Spanish: 'Posee' },
		{ value: 'lease', English: 'Lease', Spanish: 'Arrienda' },
		{ value: 'finance', English: 'Finance', Spanish: 'Financia' },
	];

	let dropdownDataList = [];

	vehicleOwnershipType.forEach(v => {
		dropdownDataList.push({ [keys.text]: v[language], [keys.value]: v.value });
	});

	return dropdownDataList;
}

//Info is not being saved in the application so we can't get the condition to show there.
//export function vehiclePlateVin(keys, language, application, toggleLoadingQuestion) {
//    const vehicleOwnershipType = [
//        { value: 'plate', English: 'License Plate', Spanish: 'Número de Placa' },
//        { value: 'vin', English: 'Vehicle Identification # (VIN)', Spanish: 'Identificación del vehículo (VIN)' },
//        { value: 'neither', English: 'Neither', Spanish: 'Ninguno' },
//    ]

//    let dropdownDataList = []

//    vehicleOwnershipType.forEach(v => {
//        dropdownDataList.push({ [keys.text]: v[language], [keys.value]: v.value })
//    })

//    return dropdownDataList
//}

export function vehicleWhoOwnsIt(keys, language, application, toggleLoadingQuestion) {
	const data = [
		{ value: 'myself', English: 'Myself', Spanish: 'Yo' },
		{ value: 'spouse', English: 'Spouse', Spanish: 'Cónyuge' },
		{ value: 'child', English: 'Child', Spanish: 'Hijo(a)' },
		{ value: 'parents', English: 'Parents', Spanish: 'Padres' },
		{ value: 'other', English: 'Other', Spanish: 'Otro' },
	];

	let dropdownDataList = [];

	data.forEach(d => {
		dropdownDataList.push({ [keys.text]: d[language], [keys.value]: d.value });
	});

	return dropdownDataList;
}

export async function vehicleMake(keys, language, application, toggleLoadingQuestion) {
	toggleLoadingQuestion();

	//MarketScan List
	let makeList = await DropdownHelper.getBrands();
	console.log('carMakeList', makeList);

	let makes = [];

	makeList.forEach(m => {
		makes.push({ [keys.text]: m.display, [keys.value]: m.display });
	});

	let rebateVehicleMake = application.quoteAppData.questions.find(q => q.key == application.quoteAppData.currentQuestion)?.savedAnswer;

	if (rebateVehicleMake) {
		let makeFoundIndex = makes.findIndex(m => m[keys.text].toLowerCase() == rebateVehicleMake.toLowerCase());

		if (makeFoundIndex >= 0 && !makes.find(m => m[keys.text] == rebateVehicleMake)) {
			application.quoteAppData.questions.find(q => q.key == application.quoteAppData.currentQuestion).savedAnswer = makes[makeFoundIndex][keys.text];
		}
	}

	////Chrome List
	//let yearIndex = application.quoteAppData.currentQuestion.split("-")[1]
	//let year = null
	//if (application.quoteAppData.currentQuestion.toLowerCase().includes('current')) {
	//    year = parseInt(application.quoteAppData.applicationsDataAnswered.rebates.rebateCurrentVehicles.vehicles[yearIndex].vehicleYear)
	//}
	//else {
	//    year = parseInt(application.quoteAppData.applicationsDataAnswered.rebates.rebateReturnedLeaseVehicles.vehicles[yearIndex].vehicleYear)
	//}

	//let makeList = await api.carMakeList(year)
	//console.log("carMakeList", makeList?.data);
	//let makes = []

	//makeList.data.forEach(m => {
	//    makes.push({ [keys.text]: m.value, [keys.value]: m.value })
	//})

	//let rebateVehicleMake = application.quoteAppData.questions.find(q => q.key == application.quoteAppData.currentQuestion)?.savedAnswer
	//console.log("rebateVehicleMake", rebateVehicleMake);

	//if (rebateVehicleMake) {
	//    let makeFoundIndex = makes.findIndex(m => m[keys.text].toLowerCase() == rebateVehicleMake.toLowerCase())
	//    console.log("makeFoundIndex", makeFoundIndex);

	//    if (makeFoundIndex >= 0 && !makes.find(m => m[keys.text] == rebateVehicleMake)) {
	//        console.log("UPDATE VALUE IF STATEMENT", makes[makeFoundIndex][keys.text]);
	//        application.quoteAppData.questions.find(q => q.key == application.quoteAppData.currentQuestion).savedAnswer = makes[makeFoundIndex][keys.text]
	//    }
	//}

	toggleLoadingQuestion();

	return makes;
}

export async function vehicleModel(keys, language, application, toggleLoadingQuestion) {
	toggleLoadingQuestion();

	//MarketScan List
	let makeList = await DropdownHelper.getBrands();
	let makeIdIndex = application.quoteAppData.currentQuestion.split('-')[1];

	let makeId = null;
	if (application.quoteAppData.currentQuestion.toLowerCase().includes('current')) {
		console.log('CURRENT', makeIdIndex);
		makeId = makeList.find(m => m.display == application.quoteAppData.applicationsDataAnswered.rebates.rebateCurrentVehicles.vehicles[makeIdIndex].vehicleMake).value
			.saturnBrandId;
		console.log('makeID', makeId);
	} else {
		console.log('RETURNED', makeIdIndex);
		makeId = makeList.find(m => m.display == application.quoteAppData.applicationsDataAnswered.rebates.rebateReturnedLeaseVehicles.vehicles[makeIdIndex].vehicleMake)
			.value.saturnBrandId;
		console.log('makeID', makeId);
	}

	let modelsList = await DropdownHelper.getModels();
	console.log('modelsList', modelsList);

	let models = [];

	modelsList.forEach(ml => {
		if (ml.value.saturnBrandId == makeId) {
			models.push({ [keys.text]: ml.display, [keys.value]: ml.display });
		}
	});
	console.log('models', models);

	let rebateVehicleModel = application.quoteAppData.questions.find(q => q.key == application.quoteAppData.currentQuestion)?.savedAnswer;

	if (rebateVehicleModel) {
		let modelFoundIndex = models.findIndex(m => m[keys.text].toLowerCase() == rebateVehicleModel.toLowerCase());

		if (modelFoundIndex >= 0 && !models.find(m => m[keys.text] == rebateVehicleModel)) {
			application.quoteAppData.questions.find(q => q.key == application.quoteAppData.currentQuestion).savedAnswer = models[modelFoundIndex][keys.text];
		}
	}

	////Chrome List
	//let yearIndex = application.quoteAppData.currentQuestion.split("-")[1]
	//let year = null
	//if (application.quoteAppData.currentQuestion.toLowerCase().includes('current')) {
	//    year = parseInt(application.quoteAppData.applicationsDataAnswered.rebates.rebateCurrentVehicles.vehicles[yearIndex].vehicleYear)
	//}
	//else {
	//    year = parseInt(application.quoteAppData.applicationsDataAnswered.rebates.rebateReturnedLeaseVehicles.vehicles[yearIndex].vehicleYear)
	//}

	//let makeList = await api.carMakeList(year)
	//let makeIdIndex = application.quoteAppData.currentQuestion.split("-")[1]

	//let makeId = null
	//if (application.quoteAppData.currentQuestion.toLowerCase().includes('current')) {
	//    console.log("CURRENT", makeIdIndex);
	//    makeId = makeList.data?.find(m => m.value == application.quoteAppData.applicationsDataAnswered.rebates.rebateCurrentVehicles.vehicles[makeIdIndex].vehicleMake).id
	//    console.log("makeID", makeId);
	//}
	//else {
	//    console.log("RETURNED");
	//    makeId = makeList.data?.find(m => m.value == application.quoteAppData.applicationsDataAnswered.rebates.rebateReturnedLeaseVehicles.vehicles[makeIdIndex].vehicleMake).id
	//    console.log("makeID", makeId);
	//}

	//let modelsList = await api.carModelList(year, makeId)
	//console.log("carModelList", modelsList?.data);

	//let models = []

	//modelsList.data?.forEach(ml => {
	//    if (!models.find(m => m.value == ml.value)) {

	//        models.push({ [keys.text]: ml.value, [keys.value]: ml.value })
	//    }
	//})

	//let rebateVehicleModel = application.quoteAppData.questions.find(q => q.key == application.quoteAppData.currentQuestion)?.savedAnswer

	//if (rebateVehicleModel) {
	//    let modelFoundIndex = models.findIndex(m => m[keys.text].toLowerCase() == rebateVehicleModel.toLowerCase())

	//    if (!models.find(m => m[keys.text] == rebateVehicleModel)) {
	//        if (modelFoundIndex >= 0) {
	//            application.quoteAppData.questions.find(q => q.key == application.quoteAppData.currentQuestion).savedAnswer = models[modelFoundIndex][keys.text]
	//        }
	//        else {
	//            models.push({ [keys.text]: rebateVehicleModel, [keys.value]: rebateVehicleModel })
	//        }
	//    }
	//}

	toggleLoadingQuestion();

	return models;
}

export function militaryBranch(keys, language, application, toggleLoadingQuestion) {
	const data = [
		{ value: 'army', English: 'Army', Spanish: 'Ejército' },
		{ value: 'navy', English: 'Navy', Spanish: 'Marina de Guerra' },
		{ value: 'airForce', English: 'Air Force', Spanish: 'Fuerza Aerea' },
		{
			value: 'nationalGuard',
			English: 'National Guard',
			Spanish: 'Guardia Nacional',
		},
		{ value: 'marines', English: 'Marines', Spanish: 'Infantería de Marina' },
		{ value: 'coastGuard', English: 'Coast Guard', Spanish: 'Guardia Costera' },
	];

	let dropdownDataList = [];

	data.forEach(d => {
		dropdownDataList.push({ [keys.text]: d[language], [keys.value]: d.value });
	});

	return dropdownDataList;
}

export function whoIsMilitary(keys, language, application, toggleLoadingQuestion) {
	const data = [
		{ value: 'me', English: 'Me', Spanish: 'Yo' },
		{ value: 'spouse', English: 'Spouse', Spanish: 'Cónyuge' },
		{ value: 'both', English: 'Both', Spanish: 'Ambos' },
		{ value: 'noOne', English: 'Neither', Spanish: 'Ninguno' },
	];

	let dropdownDataList = [];

	data.forEach(d => {
		dropdownDataList.push({ [keys.text]: d[language], [keys.value]: d.value });
	});

	return dropdownDataList;
}

export function militaryStatus(keys, language, application, toggleLoadingQuestion) {
	const data = [
		{ value: 'active', English: 'Active', Spanish: 'Activo(a)' },
		{ value: 'veteran', English: 'Veteran', Spanish: 'Veterano(a)' },
		{ value: 'inactive', English: 'Inactive', Spanish: 'Inactivo(a)' },
		{ value: 'reservist', English: 'Reservist', Spanish: 'Reserva' },
	];

	let dropdownDataList = [];

	data.forEach(d => {
		dropdownDataList.push({ [keys.text]: d[language], [keys.value]: d.value });
	});

	return dropdownDataList;
}

export function studentStatus(keys, language, application, toggleLoadingQuestion) {
	const data = [
		{ value: 'fullTime', English: 'Full-Time', Spanish: 'Tiempo completo' },
		{ value: 'partTime', English: 'Part-Time', Spanish: 'Medio Tiempo' },
		{ value: 'graduated', English: 'Graduated', Spanish: 'Graduado(a)' },
		{
			value: 'academicLeave',
			English: 'Enrolled in Academic Leave',
			Spanish: 'De Licencia Académica',
		},
	];

	let dropdownDataList = [];

	data.forEach(d => {
		dropdownDataList.push({ [keys.text]: d[language], [keys.value]: d.value });
	});

	return dropdownDataList;
}

export function institutionType(keys, language, application, toggleLoadingQuestion) {
	const data = [
		{
			value: 'highSchool',
			English: 'High School',
			Spanish: 'Preparatoria / Técnico Medio',
		},
		{ value: 'college', English: 'College', Spanish: 'Colegio Universitario' },
		{ value: 'university', English: 'University', Spanish: 'Universidad' },
		{
			value: 'tradeSchool',
			English: 'Trade School',
			Spanish: 'Escuela Técnico',
		},
		{
			value: 'registeredNursingSchool',
			English: 'Registered Nursing School',
			Spanish: 'Escuela de Enfermería Registrada',
		},
		{
			value: 'nursingSchool',
			English: 'Nursing School',
			Spanish: 'Escuela de Enfermería',
		},
	];

	let dropdownDataList = [];

	data.forEach(d => {
		dropdownDataList.push({ [keys.text]: d[language], [keys.value]: d.value });
	});

	return dropdownDataList;
}

export function estimatedCreditScore(keys, language, application, toggleLoadingQuestion) {
	const data = [
		{ value: 'poorCredit', English: 'Under 579', Spanish: 'Menos de 579' },
		{ value: 'fairCredit', English: '580 - 669', Spanish: '580 - 669' },
		{ value: 'goodCredit', English: '670 - 739', Spanish: '670 - 739' },
		{ value: 'veryGoodCredit', English: '740 - 799', Spanish: '740 - 799' },
		{ value: 'excelentCredit', English: 'Over 800', Spanish: 'Más de 800' },
		{ value: 'dontknowCredit', English: "Don't know", Spanish: 'No lo sé' },
	];

	let dropdownDataList = [];

	data.forEach(d => {
		dropdownDataList.push({ [keys.text]: d[language], [keys.value]: d.value });
	});

	return dropdownDataList;
}

export function enterpriseTypes(keys, language, application, toggleLoadingQuestion) {
	const data = [
		{ value: 'corporation', English: 'Corporation', Spanish: 'Corporación' },
		{ value: 'llc', English: 'LLC', Spanish: 'SRL' },
		{ value: 'partnership', English: 'Partnership', Spanish: 'Sociedad' },
		{ value: 'proprietor', English: 'Proprietor', Spanish: 'Propietario' },
	];

	let dropdownDataList = [];

	data.forEach(d => {
		dropdownDataList.push({ [keys.text]: d[language], [keys.value]: d.value });
	});

	return dropdownDataList;
}

export function businessLocationOwnershipStatus(keys, language, application, toggleLoadingQuestion) {
	const data = [
		{ value: 'mortgage', English: 'Mortgage', Spanish: 'Hipotecada' },
		{ value: 'rental', English: 'Rental', Spanish: 'Alquilada' },
		{ value: 'own', English: 'Own', Spanish: 'Propia' },
	];

	let dropdownDataList = [];

	data.forEach(d => {
		dropdownDataList.push({ [keys.text]: d[language], [keys.value]: d.value });
	});

	return dropdownDataList;
}

export function residenceOwnershipStatus(keys, language, application, toggleLoadingQuestion) {
	const data = [
		{ value: 'mortgage', English: 'Mortgage', Spanish: 'Hipoteca' },
		{ value: 'rental', English: 'Rental', Spanish: 'Alquiler' },
		{ value: 'own', English: 'Own', Spanish: 'Propietario' },
		{
			value: 'familyOther',
			English: 'Live with Family/Other',
			Spanish: 'Vivo con mi Familia/Otro',
		},
	];

	let dropdownDataList = [];

	data.forEach(d => {
		dropdownDataList.push({ [keys.text]: d[language], [keys.value]: d.value });
	});

	return dropdownDataList;
}

//Info is not being saved in the application so we can't get the condition to show there.
//export function insuranceAndTaxes(keys, language, application, toggleLoadingQuestion) {
//    const data = [
//        { value: 'insurance', English: 'Insurance', Spanish: 'Seguro' },
//        { value: 'taxes', English: 'Taxes', Spanish: 'Impuestos' },
//        { value: 'both', English: 'Both', Spanish: 'Ambos' },
//        { value: 'no', English: 'No', Spanish: 'No' },
//    ]
//    let dropdownDataList = []

//    data.forEach(d => {
//        dropdownDataList.push({ [keys.text]: d[language], [keys.value]: d.value })
//    })

//    return dropdownDataList
//}

export function liveWithFamily(keys, language, application, toggleLoadingQuestion) {
	const data = [
		{ value: 'parents', English: 'Parents', Spanish: 'Padres' },
		{ value: 'siblings', English: 'Siblings', Spanish: 'Hermanos' },
		{ value: 'other', English: 'Other', Spanish: 'Otro' },
	];

	let dropdownDataList = [];

	data.forEach(d => {
		dropdownDataList.push({ [keys.text]: d[language], [keys.value]: d.value });
	});

	return dropdownDataList;
}

export function employmentFormType(keys, language, application, toggleLoadingQuestion) {
	const data = [
		{ value: 'w2', English: 'W2', Spanish: 'W2' },
		{ value: '1099', English: '1099', Spanish: '1099' },
	];
	let dropdownDataList = [];

	data.forEach(d => {
		dropdownDataList.push({ [keys.text]: d[language], [keys.value]: d.value });
	});

	return dropdownDataList;
}

export function paymentType(keys, language, application, toggleLoadingQuestion) {
	const data = [
		{ value: 'hourly', English: 'Hourly', Spanish: 'Por hora' },
		{ value: 'salary', English: 'Salary', Spanish: 'Salario' },
	];
	let dropdownDataList = [];

	data.forEach(d => {
		dropdownDataList.push({ [keys.text]: d[language], [keys.value]: d.value });
	});

	return dropdownDataList;
}

export function noEmployedStatus(keys, language, application, toggleLoadingQuestion) {
	const data = [
		{ value: 'retired', English: 'Retired', Spanish: 'Retirado(a)' },
		{ value: 'disabled', English: 'Disabled', Spanish: 'Desabilitado(a)' },
		{ value: 'student', English: 'Student', Spanish: 'Estudiante' },
		{ value: 'unemployed', English: 'Unemployed', Spanish: 'Desempleado(a)' },
		{ value: 'other', English: 'Other', Spanish: 'Otro' },
	];

	let dropdownDataList = [];

	data.forEach(d => {
		dropdownDataList.push({ [keys.text]: d[language], [keys.value]: d.value });
	});

	return dropdownDataList;
}

export function allFrequencies(keys, language, application, toggleLoadingQuestion) {
	const data = [
		{ value: 'weekly', English: 'Weekly', Spanish: 'Semanalmente' },
		{ value: 'biWeekly', English: 'BiWeekly', Spanish: 'Quincenalmente' },
		{ value: 'monthly', English: 'Monthly', Spanish: 'Mensualmente' },
		{ value: 'quarterly', English: 'Quarterly', Spanish: 'Trimestralmente' },
		{ value: 'semiAnnual', English: 'Semi-Annual', Spanish: 'Semestralmente' },
		{ value: 'annually', English: 'Annually', Spanish: 'Anualmente' },
	];

	let dropdownDataList = [];

	data.forEach(d => {
		dropdownDataList.push({ [keys.text]: d[language], [keys.value]: d.value });
	});

	return dropdownDataList;
}

export function monthlyAndAnnuallyFrequencies(keys, language, application, toggleLoadingQuestion) {
	let dropdownDataList = allFrequencies(keys, language, application, toggleLoadingQuestion).filter(f => f.value == 'monthly' || f.value == 'annually');

	return dropdownDataList;
}

export function frequenciesWithoutQuarterlyAndSemiAnnual(keys, language, application, toggleLoadingQuestion) {
	let dropdownDataList = allFrequencies(keys, language, application, toggleLoadingQuestion).filter(f => f.value != 'quarterly' && f.value != 'semiAnnual');

	return dropdownDataList;
}

export async function addresses(keys, language, application, searchText) {
	let zipCode = null;
	let mapService = new MapsService();
	let country = null;

	if (application.quoteAppData.currentQuestion == 'provideStreetAddress') {
		zipCode = application.quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.zipCode;

		let usTerritory = application.quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.usTerritory;
		country = usTerritory && usTerritory != 'US' ? usTerritory : null;
	} else {
		zipCode = application.quoteAppData.applicationsDataAnswered.personalInfo.previousResidence.zipCode;

		let usTerritory = application.quoteAppData.applicationsDataAnswered.personalInfo.previousResidence.usTerritory;
		country = usTerritory && usTerritory != 'US' ? usTerritory : null;
	}

	if (searchText && searchText.length >= 3) {
		//FALL BACK ZIP CODE LOOK UP
		let zipCodeData = null;
		let zipCodeResponse = await api.address.getZipcodeDetails(zipCode);
		if (zipCodeResponse && zipCodeResponse.data && zipCodeResponse.data.lat && zipCodeResponse.data.long) {
			zipCodeData = {
				zipcode: zipCodeResponse.data.zipCode,
				lat: zipCodeResponse.data.lat,
				lng: zipCodeResponse.data.long,
				city: zipCodeResponse.data.city,
				state: zipCodeResponse.data.state,
			};
		}
		await mapService.searchAddresses(searchText, { description: '-- NOT LISTED --' }, zipCodeData, country);
	}

	return mapService.results;
}
